import { AllowanceEnums, SecondaryInputTypes, ServiceTypes } from '@pharmaplan/common';
import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';
import strings from '../../../../localization';

const { meal, travel, accommodation, emergency, others } = AllowanceEnums;
const { field, dropdown } = SecondaryInputTypes;

const isSelfService = ServiceTypes.self === ServiceHandler.getService();

export const allowanceConfig = () =>
  [
    {
      key: meal,
      label: strings.mealAllowances,
      secondaryInput: field,
    },
    {
      key: travel,
      label: strings.travelAllowances,
      secondaryInput: dropdown,
    },
    {
      key: accommodation,
      label: strings.accommodationAllowances,
      secondaryInput: dropdown,
    },
    {
      key: emergency,
      label: strings.emergencyServiceFees,
      secondaryInput: field,
    },
    isSelfService && {
      key: others,
      label: strings.other,
      secondaryInput: field,
    },
  ].filter(Boolean) as Array<{ key: AllowanceEnums; label: string; secondaryInput: string }>;
